import React from 'react';
import './V1PipelineStrip.css';

const DEFAULT_STAGES = [
    { id: 1, key: 'scan', label: 'SCAN', desc: 'CNC · NSE+BSE degen sweep' },
    { id: 2, key: 'predict', label: 'PREDICT', desc: 'UP delivery momentum' },
    { id: 3, key: 'validate', label: 'VALIDATE', desc: 'Master band · CNC LONG' },
    { id: 4, key: 'fill', label: 'FILL BUY', desc: '1 CNC stock / 1 min → BUY tab' }
];

function stageStatus(activeStage, index) {
    if (index < activeStage) return 'done';
    if (index === activeStage) return 'active';
    return 'pending';
}

export default function V1PipelineStrip({ pipeline }) {
    if (!pipeline) {
        return (
            <section className="v1-pipeline card v1-pipeline-placeholder">
                <header className="v1-pipeline-head">
                    <h3>CNC DELIVERY PIPELINE <span className="v1-pipeline-brain-badge">CNC · DEGEN</span></h3>
                    <span>Loading — NSE/BSE CNC scan → master band → FILL BUY…</span>
                </header>
            </section>
        );
    }

    const stages = pipeline.stages || DEFAULT_STAGES;
    const activeStage = pipeline.activeStage ?? 0;
    const progress = pipeline.stageProgress ?? 0;
    const fillSec = pipeline.fillCountdownSec ?? pipeline.fillIntervalSec ?? 60;
    const brainLabel = pipeline.brainLabel || 'EINSTEIN BRAIN';

    return (
        <section className="v1-pipeline card">
            <header className="v1-pipeline-head">
                <h3>
                    {pipeline.label || 'AI BUY PIPELINE'}
                    <span className="v1-pipeline-brain-badge">{brainLabel}</span>
                </h3>
                <span>{pipeline.strategyNote || pipeline.subtitle || 'Einstein scan → profit validate → 1 stock / 1 min'}</span>
            </header>
            {pipeline.candleConfirmBuy !== false && (
                <p className="v1-pipeline-candle-note">
                    {pipeline.buyConfirmMode === 'fee-aware-momentum'
                        ? 'Fee-aware ON'
                        : 'Candle confirm only'}
                    {pipeline.candleConfirmStats
                        ? ` · last ${pipeline.candleConfirmStats.up ?? 0} UP / ${pipeline.candleConfirmStats.kept ?? 0} kept`
                        : ''}
                    {pipeline.candleConfirmStats?.niftyWeak ? ' · Nifty weak · RS leaders' : ''}
                    {' · '}
                    <em>
                      {pipeline.buyConfirmMode === 'fee-aware-momentum'
                        ? 'V1: Rollback to candle confirm'
                        : 'V1: Enable fee-aware momentum'}
                    </em>
                </p>
            )}
            <div className="v1-pipeline-row">
                {stages.map((stage, i) => {
                    const status = stageStatus(activeStage, i);
                    const meta = pipeline.cycleMeta?.[stage.key] || {};
                    const isFill = stage.key === 'fill';
                    return (
                        <div key={stage.key} className={`v1-pipe-card ${status}`}>
                            <div className="v1-pipe-num">{stage.id}</div>
                            <strong>{stage.label}</strong>
                            <p>{meta.detail || stage.desc}</p>
                            <small>
                                {isFill && status === 'active'
                                    ? `Next in ${fillSec}s`
                                    : (meta.sub || (status === 'active' ? `${Math.round(progress)}%` : '—'))}
                            </small>
                            {status === 'active' && (
                                <div className="v1-pipe-progress">
                                    <div style={{ width: `${progress}%` }} />
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
            {pipeline.topPick && (
                <p className="v1-pipeline-signal">
                    Einstein pick: <strong>{pipeline.topPick.stock}</strong>
                    {' '}· <span className={(pipeline.topPick.direction || 'UP') === 'UP' ? 'up' : 'down'}>
                        {pipeline.topPick.direction || 'UP'} {pipeline.topPick.einsteinScore ?? pipeline.topPick.displayWin ?? pipeline.topPick.score}%
                    </span>
                    {' '}· ₹{Number(pipeline.topPick.price).toFixed(2)}
                    {pipeline.topPick.profitMovePct != null ? ` · need +${pipeline.topPick.profitMovePct}% for ₹0.50/sh` : ''}
                    {pipeline.buyCount != null ? ` · BUY ${pipeline.buyCount}/${pipeline.slotsMax ?? 5}` : ''}
                </p>
            )}
        </section>
    );
}
